import localForage from 'localforage';
import { extendPrototype as setItemsExtend } from 'localforage-setitems';
import { extendPrototype as startsWithExtend } from 'localforage-startswith';

setItemsExtend(localForage);
startsWithExtend(localForage);

export default {
    install (Vue, options) {
        Vue.prototype.$vlf = function(storeName) {
            return localForage.createInstance({
                name: 'anm22_world',
                storeName: storeName
            });
        };
    }
}